// LIBRARIES
import { COLORS, DEVICE_TYPE, MARGIN, SIZE } from "constants/variables";
import styled from "styled-components";

//MISC;

export const CivicDialogueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionsRow2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
  height: 100%;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding-top: 24px;
  }
`;

export const CarouselWrapper = styled.div`
  height: 552px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;
  margin-bottom: 100px;
  padding: 0px ${MARGIN.max80};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    height: 637px;
    padding: 0px ${MARGIN.max24};
    margin-bottom: 0px;
    margin-top: 50px;
  }
`;

export const SectionId = styled.div`
  scroll-margin-top: var(--navigation-offset, 164px);
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${SIZE.max40} 0;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0;
  }
`;
